<template>
  <div class="tabBar">
    <div
      :style="{
        background: datas.backColor,
        'border-style': datas.borderStyle,
        'border-color': datas.borderColor,
        'border-width': datas.borderLineWeight + 'px',
        'border-radius': datas.borderRadius + 'px',
        'padding-top': datas.paddingTop + 'px',
        'padding-bottom': datas.paddingBottom + 'px',
        'padding-left': datas.paddingLeft + 'px',
        'padding-right': datas.paddingRight + 'px',
        'margin-top': datas.marginTop + 'px',
        'margin-bottom': datas.marginBottom + 'px',
        'margin-left': datas.marginLeft + 'px',
        'margin-right': datas.marginRight + 'px',
      }"
    >
      <section>
        <div v-if="datas.styleType == 1" class="tab_title_con">
          <div
            :style="{
              'font-size': datas.wordSizeTitle + 'px',
              'font-weight': datas.isBoldTitle ? 'bold' : 'normal',
              'font-style': datas.isTiltTitle ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLineTitle ? 'underline' : 'none',
              color: datas.wordColorTitle,
            }"
          >
            {{ datas.name }}
          </div>
          <div
            :style="{
              'font-size': datas.wordSizeDesc + 'px',
              'font-weight': datas.isBoldDesc ? 'bold' : 'normal',
              'font-style': datas.isTiltDesc ? 'italic' : 'normal',
              'text-decoration': datas.isUnderLineDesc ? 'underline' : 'none',
              color: datas.wordColorDesc,
            }"
            @click="handleClickTab(datas)"
          >
            {{ datas.descName }} <i class="iconfont icon-xiangyou" />
          </div>
        </div>
        <div v-if="datas.imageList.length == 0" class="nav_con">
          <div
            v-for="index in 4"
            :key="index"
            :class="[{ nav_item_3: datas.styleType == 3 }, 'nav_item']"
          >
            <img draggable="false" :src="defaultImg" alt="" />
            <div
              :style="{
                'font-size': datas.wordSize + 'px',
                'font-weight': datas.isBold ? 'bold' : 'normal',
                'font-style': datas.isTilt ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                color: datas.wordColor,
              }"
            >
              XXX
            </div>
          </div>
        </div>
        <div v-else class="nav_con">
          <div
            v-for="(item, index) in datas.imageList"
            :key="index"
            :class="[{ nav_item_3: datas.styleType == 3 }, 'nav_item']"
            @click="handleClickTab(item)"
          >
            <div style="position: relative">
              <img draggable="false" :src="item.imgUrl || defaultImg" alt="" />
              <div
                v-if="handleSetShow(item.title)"
                class="badge_con"
                :style="{
                  background: datas.badgeColor,
                }"
              >
                2
              </div>
            </div>

            <div
              :style="{
                'font-size': datas.wordSize + 'px',
                'font-weight': datas.isBold ? 'bold' : 'normal',
                'font-style': datas.isTilt ? 'italic' : 'normal',
                'text-decoration': datas.isUnderLine ? 'underline' : 'none',
                color: datas.wordColor,
              }"
            >
              {{ item.title ? item.title : "XXX" }}
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
import { handleScanCode } from "@/utils";
export default {
  name: "Ordertab",
  props: {
    datas: Object,
  },
  data() {
    return {
      defaultImg: require("@/assets/images/defaultPic2.png"),
    };
  },

  computed: {},

  watch: {},

  created() {
    // document.querySelector(".phone-container").style.cssText =
    //   "padding-bottom: 50px";
  },

  mounted() {},

  beforeDestroy() {
    // document.querySelector(".phone-container").style.cssText =
    //   "padding-bottom: 0px";
  },

  methods: {
    handleSetShow(title) {
      return (
        ((title == "待付款" || title == "我的订单") &&
          this.datas.showContents.includes(1)) ||
        ((title == "我的票券" || title == "待使用") &&
          this.datas.showContents.includes(2))
      );
    },
    handleClickTab(item) {
      if (item.linkType == "scanCode") {
        // 调起微信扫码，扫码取号并自动跳转到扫码信息页面
        handleScanCode();
      } else if (item.linkUrl) {
        window.location.href = item.linkUrl;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabBar {
  position: relative;
  .tab_title_con {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    margin: 0 20px;
    border-bottom: 1px solid #dedede;
    .iconfont {
      font-size: 26px;
    }
  }
  .nav_con {
    display: flex;

    .nav_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex: 1;
      position: relative;
      margin: 20px 0;
      img {
        margin-bottom: 10px;
        width: 60px;
        height: 60px;
      }
      .badge_con {
        position: absolute;
        right: -10px;
        top: -10px;
        height: 30px;
        line-height: 30px;
        border-radius: 16px;
        padding: 0 10px;
        text-align: center;
        color: #fff;
        font-size: 16px;
      }
      &.nav_item_3 {
        background: #f8f8fa;
        margin: 20px 0 20px 20px;
        padding: 20px 0;
        &:last-child {
          margin-right: 20px;
        }
        // padding: 8px;
      }
    }
  }
}
</style>
